import { useEffect, useState, useRef } from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Header, CustomButton, PoweredByLogo } from "../../components";
import useApp from "../../hooks/useApp";
import { logAnalyticEvent } from "../../analytics";
import { EVENT_NAME } from "../../constants";
import { convertTimestamp } from "../../utils";
import { Close } from "../../assets/svgs";
import "./styles.scss";

const TermsAndPrivacyModal = ({ visible, onClickClose, data, docType }) => {
  const { selectedLanguage, handleIsTCAccepted } = useApp();
  const { t } = useTranslation();

  const contentRef = useRef(null);

  const [startTime, setStartTime] = useState(0);

  const handleAcceptAndContinue = () => {
    handleIsTCAccepted(true);
    onClickClose();
  };

  useEffect(() => {
    if (visible && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    setStartTime(Date.now());
    return () => {
      const endTime = Date.now();
      logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
        page_title: docType,
        path: `${window.location.origin}/${docType}`,
        end_time: endTime,
        start_time: startTime,
        time_spent: convertTimestamp(endTime - startTime),
      });
    };
  }, [visible]);

  return (
    <div className={`terms-and-privacy-modal ${visible ? "show" : "hide"}`}>
      <div className="terms-and-privacy-modal-content" ref={contentRef}>
        <Header
          containerStyle={"d-flex justify-content-end w-100"}
          rightIcon={Close}
          onClickRightIcon={onClickClose}
          rightIconStyle={{
            width: "1.25rem",
            height: "1.25rem",
            cursor: "pointer",
          }}
        />
        {data ? (
          <>
            <h1 className="title">{data?.title[selectedLanguage?.value]}</h1>
            <p className="last-update-text">
              {t("termsAndConditions.date_label")}{" "}
              {format(new Date(data.updated_on), "dd/MM/yyyy")}
            </p>
            <div
              className="terms-and-conditions-content"
              dangerouslySetInnerHTML={{
                __html: data?.content[selectedLanguage?.value],
              }}
            />
            <CustomButton
              text={t("app.got_it")}
              onClick={handleAcceptAndContinue}
            />
            <PoweredByLogo />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default TermsAndPrivacyModal;
